/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-multi-comp */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useLazyQuery, useQuery } from '@apollo/client';
import { STATES_BY_COUNTRY, CITY_BY_STATE } from 'pages/MarketListing/MarketListingGraphQL';
import { STAFF_LIST_QUERY } from 'pages/Staff/StaffgraphQL';
import { PRODUCT_LIST } from 'pages/Products/ProductsGraphQL';
import {
  Button,
  Input,
} from 'reactstrap';
import DateFormatter from 'components/DateFormatter';
import Select from 'react-select';
import { BiTrash } from 'react-icons/bi';
import {
  FiEdit2,
  FiPhoneCall,
  FiCheck,
  FiX,
} from 'react-icons/fi';
import { APP_TOKEN } from 'constants';
import { defaultDeleteFilter } from 'utils/constants';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as XLSX from 'xlsx';
import './style.css';
import CreateLead from './CreateLead';
import GetLead from './GetLead';
import UpdateLead from './UpdateLead';

const INLINE_EDITABLE_FIELDS = {
  companyName: 'companyName',
  email: 'email',
  website: 'website',
  phoneNoCount: 'phoneNoCount',
  phone1: 'phone1',
  leadOwner: 'leadOwner',
  leadStage: 'leadStage',
  currency: 'currency',
  email2: 'email2',
  gstin: 'gstin',
  followUpCount: 'followUpCount',
  appId: 'appId',
  sourceOfLead: 'sourceOfLead',
  landlineNo: 'landlineNo',
  businessDescription: 'businessDescription',
  street: 'street',
  cityId: 'cityId',
  stateId: 'stateId',
  countryId: 'countryId',
  zipCode: 'zipCode',
  averageConsumption: 'averageConsumptionMonthlyTons',
  otherReason: 'otherReason',
  customerId: 'customerId',
  registeredContactPersonNameOnApp: 'registeredContactPersonNameOnApp',
  emailAddressOnApp: 'emailAddressOnApp',
  registeredGstin: 'registeredGSTIN',
  registeredMobileNumberOnApp: 'registeredMobileNumberOnApp',
  apiDataLead: 'apiDataLead',
  leadName: 'firstName',
  companyIntro: 'companyIntro',
  leadPersonDesignation: 'leadPersonDesignation',
  typeOfPolymer: 'typeOfPolymer',
  pitchedForAdSpace: 'pitchedForAdSpace',
  appDownloaded: 'appDownloaded',
  kycCompleted: 'kycCompleted',
  planExpiryDate: 'planExpiryDate',
  subscriptionPlanType: 'subscriptionPlanType',
  seededTime: 'seededTime',
  typeOfClient: 'typeOfClient',
  rnr: 'rnr',
  exchangeRate: 'exchangeRate',
  reasonForLostLead: 'reasonForLostLead',
  salesLeadStatus: 'salesLeadStatus',
  uploadWhatsappImage: 'uploadWhatsappImage',
  uploadCallingAudio: 'uploadCallingAudio',
  uploadVisitingCard: 'uploadVisitingCard',
  whatsappUploadStatus: 'whatsappUploadStatus',

};

function renderNoWrapValue(value) {
  return <div className="text-nowrap crm-lead-nowrap">{value}</div>;
}

const renderLeadDeleteCell = ({ row, onDelete, deletingId }) => (
  <div className="crm-lead-page__table-action-cell">
    <button
      type="button"
      className="btn btn-link crm-lead-page__delete-btn"
      aria-label={`Delete lead ${row?.original?.leadName || row?.original?.companyName || row?.original?.id}`}
      title="Delete"
      onClick={(event) => {
        event.stopPropagation();
        onDelete(row?.original?.id);
      }}
      disabled={deletingId === row?.original?.id}
    >
      <BiTrash size={18} />
    </button>
  </div>
);

const CRM_API_ROOT = `${process.env.REACT_APP_REST_API_ENDPOINT || ''}crm`;

const CREATE_LEAD_PERSON_DESIGNATION_MAP = {
  Owner: 'OWNER',
  Manager: 'MANAGER',
  'Sales Executive': 'SALES_EXECUTIVE',
  Director: 'DIRECTOR',
};

const CREATE_LEAD_CLIENT_TYPE_MAP = {
  Trader: 'TRADER',
  Manufacturer: 'MANUFACTURER',
  Exporter: 'EXPORTER',
  Other: 'OTHER',
};

const CREATE_LEAD_STATUS_MAP = {
  Open: 'OPEN',
  Working: 'WORKING',
  Won: 'WON',
  Lost: 'LOST',
  HOT: 'HOT',
  WARM: 'WARM',
  COLD: 'COLD',
};

const CREATE_LEAD_RNR_MAP = {
  Yes: true,
  No: false,
};

const CREATE_LEAD_BOOLEAN_MAP = {
  Yes: true,
  No: false,
};

const CREATE_LEAD_UPLOAD_STATUS_MAP = {
  Pending: 'PENDING',
  Uploaded: 'UPLOADED',
  Skipped: 'SKIPPED',
};

const CREATE_LEAD_STAGE_MAP = {
  'New Lead': 'NEW_LEAD',
  RNR: 'RNR',
  'First Call Sales Pitch(FCSP)': 'FIRST_CALL_SALES_PITCH',
  Seeded: 'SEEDED',
  'Follow Up': 'FOLLOW_UP',
  'Lead Lost': 'LEAD_LOST',
};


const CREATE_LEAD_SUBSCRIPTION_PLAN_MAP = {
  'Free Trial 30D': 'FREE_TRIAL_30D',
  Paid: 'PAID',
  Custom: 'CUSTOM',
};

const CREATE_LEAD_LOST_REASON_MAP = {
  'Delay in follow up': 'DELAY_IN_FOLLOW_UP',
  'Budget issue': 'BUDGET_ISSUE',
  'Competitor chosen': 'COMPETITOR_CHOSEN',
  'No requirement': 'NO_REQUIREMENT',
  Other: 'OTHER',
};

const getStoredAuth = () => {
  if (typeof window === 'undefined') return null;

  const storedAuth = window.localStorage.getItem(APP_TOKEN);
  if (!storedAuth) return null;

  try {
    return JSON.parse(storedAuth);
  } catch (error) {
    return null;
  }
};

const getStoredToken = () => {
  const auth = getStoredAuth();
  return (
    auth?.data?.token ||
    auth?.token ||
    auth?.accessToken ||
    auth?.jwt ||
    auth?.userLogin?.token ||
    null
  );
};

const getLeadDisplayName = (lead) => {
  const parts = [lead?.firstName, lead?.lastName].filter(Boolean);
  return parts.join(' ').trim() || lead?.companyName || `Lead #${lead?.id || ''}`;
};

const formatEpochSeconds = (value, format = 'YYYY-MM-DDTHH:mm:ss') => {
  if (value === null || value === undefined || value === '') return '';

  const numericValue = Number(value);
  if (Number.isFinite(numericValue)) {
    const parsed = moment(numericValue > 1e12 ? numericValue : numericValue * 1000);
    if (parsed.isValid()) {
      return parsed.format(format);
    }
  }

  const parsedFallback = moment(value);
  if (parsedFallback.isValid()) {
    return parsedFallback.format(format);
  }

  return '';
};

const formatMaybeArrayDate = (value, format = 'YYYY-MM-DD') => {
  if (!value) return '';

  if (Array.isArray(value) && value.length >= 3) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = value;
    const parsed = moment({
      year: Number(year),
      month: Number(month) - 1,
      date: Number(day),
      hour: Number(hour),
      minute: Number(minute),
      second: Number(second),
    });

    if (parsed.isValid()) {
      return parsed.format(format);
    }
  }

  const parsed = moment(value);
  if (parsed.isValid()) {
    return parsed.format(format);
  }

  return `${value}`;
};

const getCurrencyLabel = (countryCurrency) =>
  countryCurrency?.currency ||
  countryCurrency?.currencyName ||
  '';

const getCurrencyValue = (countryCurrency) =>
  countryCurrency?.id ?? '';

const buildCurrencyOptions = (countryData = []) => {
  const currencyOptionMap = new Map();

  countryData.forEach((countryCurrency) => {
    const label = getCurrencyLabel(countryCurrency);
    if (!label) return;

    const value = getCurrencyValue(countryCurrency);

    // Ek hi currency code (jaise EUR) kai countries me repeat hota hai —
    // isliye "label" (currency code) se dedupe karo, value se nahi.
    if (!currencyOptionMap.has(label)) {
      currencyOptionMap.set(label, {
        label,
        value,
      });
    }
  });

  return Array.from(currencyOptionMap.values());
};

const findOptionByValueOrLabel = (options, value) =>
  (options || []).find((option) =>
    String(option.value) === String(value) ||
    String(option.label) === String(value),
  );

const getLeadCurrencyValue = (lead) =>
  lead?.currencyId ||
  lead?.currency?.id ||
  lead?.currency ||
  lead?.currencyName ||
  '';

const getLeadCurrencyDisplayValue = (lead, currencyOptions = []) => {
  const rawCurrencyValue = getLeadCurrencyValue(lead);
  if (!rawCurrencyValue) return '—';

  return findOptionByValueOrLabel(currencyOptions, rawCurrencyValue)?.label || rawCurrencyValue;
};

const normalizeLeadRecord = (lead) => {
  const leadName = getLeadDisplayName(lead);
  const number = lead?.phone1 || lead?.registeredMobileNumberOnApp || lead?.number || '';
  const email = lead?.email || lead?.emailAddressOnApp || '';
  const reason =
    lead?.reasonOfLostLead ||
    lead?.otherReason ||
    lead?.apiDataLead ||
    lead?.sourceOfLead ||
    '';

  return {
    ...lead,
    leadOwnerId: lead?.leadOwnerId || lead?.leadOwner?.id || lead?.leadOwner?.userId || '',
    leadOwnerName:
      lead?.leadOwnerName ||
      [lead?.leadOwner?.firstName, lead?.leadOwner?.middleName, lead?.leadOwner?.lastName]
        .filter(Boolean)
        .join(' ') ||
      '',
    leadName,
    number,
    email,
    reason,
    date: lead?.date || formatEpochSeconds(lead?.createdAt, 'YYYY-MM-DD'),
    createdTime:
      lead?.createdTime || formatEpochSeconds(lead?.createdAt, 'YYYY-MM-DDTHH:mm:ss'),
    lastActivityTime:
      lead?.lastActivityTime ||
      formatEpochSeconds(lead?.updatedAt || lead?.createdAt, 'YYYY-MM-DDTHH:mm:ss'),
    modifiedTime:
      lead?.modifiedTime ||
      formatEpochSeconds(lead?.updatedAt || lead?.createdAt, 'YYYY-MM-DDTHH:mm:ss'),
    leadOwner:
      lead?.leadOwnerId ||
      lead?.leadOwner?.id ||
      lead?.leadOwner?.userId ||
      lead?.leadOwnerName ||
      lead?.leadOwner ||
      '',
    currency: lead?.currencyName || lead?.currency || '',
    planExpiryDate: formatMaybeArrayDate(lead?.planExpiryDate, 'YYYY-MM-DD'),
    seededTime: formatMaybeArrayDate(lead?.seededTime, 'YYYY-MM-DDTHH:mm:ss'),
  };
};

const normalizeLeadListResponse = (payload) => {
  const rawList = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.leads)
      ? payload.leads
      : Array.isArray(payload?.data?.data?.leads)
        ? payload.data.data.leads
        : Array.isArray(payload?.data?.leads)
          ? payload.data.leads
          : Array.isArray(payload?.data)
            ? payload.data
            : [];

  return rawList.map(normalizeLeadRecord);
};

const buildCreateLeadPayload = (values, leadImageName) => {
  const leadOwnerId = Number(values.leadOwner) || Number(values.leadOwnerId) || null;
  const currencyId = Number(values.currency) || Number(values.currencyId) || null;

  return {
    leadImage: leadImageName || values.leadImage || null,
    leadOwnerId,
    leadStage: CREATE_LEAD_STAGE_MAP[values.leadStage] || values.leadStage || 'NEW_LEAD',
    firstName: values.firstName || null,
    lastName: values.lastName || null,
    companyName: values.companyName || '',
    leadPersonDesignation:
      CREATE_LEAD_PERSON_DESIGNATION_MAP[values.leadPersonDesignation] ||
      values.leadPersonDesignation ||
      null,
    email: values.email || null,
    salesLeadStatus: CREATE_LEAD_STATUS_MAP[values.salesLeadStatus] || values.salesLeadStatus || null,
    website: values.website || null,
    email2: values.email2 || null,
    phoneNoCount: Number(values.phoneNoCount || 1),
    gstin: values.gstin || null,
    phone1: values.phone1 || null,
    rnr:
      typeof values.rnr === 'boolean'
        ? values.rnr
        : CREATE_LEAD_RNR_MAP[values.rnr] ?? null,
    currencyId,
    exchangeRate: values.exchangeRate ? Number(values.exchangeRate) : null,
    followUpCount: values.followUpCount ? Number(values.followUpCount) : null,
    appId: values.appId || null,
    companyIntro: values.companyIntro || null,
    sourceOfLead: values.sourceOfLead || null,
    landlineNo: values.landlineNo || null,
    pitchedForAdSpace:
      typeof values.pitchedForAdSpace === 'boolean'
        ? values.pitchedForAdSpace
        : CREATE_LEAD_BOOLEAN_MAP[values.pitchedForAdSpace] ?? null,
    businessDescription: values.businessDescription || null,
    street: values.street || null,
    cityId: values.cityId ? Number(values.cityId) : null,
    stateId: values.stateId ? Number(values.stateId) : null,
    countryId: values.countryId ? Number(values.countryId) : null,
    zipCode: values.zipCode || null,
    polymerTypeId: Number(values.typeOfPolymer) || Number(values.polymerTypeId) || null,
    clientType: CREATE_LEAD_CLIENT_TYPE_MAP[values.typeOfClient] || values.clientType || null,
    averageConsumptionMonthlyTons: values.averageConsumption
      ? Number(values.averageConsumption)
      : values.averageConsumptionMonthlyTons
        ? Number(values.averageConsumptionMonthlyTons)
        : null,
    whatsappImage: values.uploadWhatsappImage || values.whatsappImage || null,
    callingAudio: values.uploadCallingAudio || values.callingAudio || null,
    visitingCard: values.uploadVisitingCard || values.visitingCard || null,
    otherReason: values.otherReason || null,
    whatsappAudioImageUploadStatus:
      CREATE_LEAD_UPLOAD_STATUS_MAP[values.whatsappUploadStatus] ||
      CREATE_LEAD_UPLOAD_STATUS_MAP[values.whatsappAudioImageUploadStatus] ||
      values.whatsappAudioImageUploadStatus ||
      null,
    appDownloaded:
      typeof values.appDownloaded === 'boolean'
        ? values.appDownloaded
        : CREATE_LEAD_BOOLEAN_MAP[values.appDownloaded] ?? null,
    kycCompleted:
      typeof values.kycCompleted === 'boolean'
        ? values.kycCompleted
        : CREATE_LEAD_BOOLEAN_MAP[values.kycCompleted] ?? null,
    customerId: values.customerId || null,
    registeredGSTIN: values.registeredGstin || null,
    registeredContactPersonNameOnApp: values.registeredContactPersonNameOnApp || null,
    registeredMobileNumberOnApp: values.registeredMobileNumberOnApp || null,
    emailAddressOnApp: values.emailAddressOnApp || null,
    subscriptionPlan:
      CREATE_LEAD_SUBSCRIPTION_PLAN_MAP[values.subscriptionPlan] ||
      CREATE_LEAD_SUBSCRIPTION_PLAN_MAP[values.subscriptionPlanType] ||
      values.subscriptionPlan ||
      values.subscriptionPlanType ||
      null,
    planExpiryDate: values.planExpiryDate || null,
    seededTime: values.seededTime || null,
    reasonForLostLead:
      CREATE_LEAD_LOST_REASON_MAP[values.reasonForLostLead] ||
      values.reasonForLostLead ||
      null,
    apiDataLead: values.apiDataLead || null,
  };
};

const CRM_COLUMNS = [
  { accessorKey: 'date', header: 'Date' },
  { accessorKey: 'leadName', header: 'Lead name' },
  { accessorKey: 'companyName', header: 'Company name' },
  { accessorKey: 'leadStage', header: 'Lead stage' },
  {
    accessorKey: 'number',
    header: 'Number',
    cell: ({ row }) => renderNoWrapValue(row?.original?.number),
  },
  { accessorKey: 'email', header: 'Email' },
  { accessorKey: 'reason', header: 'Reason' },
  {
    accessorKey: 'createdTime',
    header: 'Created time',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdTime} />,
  },
  { accessorKey: 'sourceOfLead', header: 'Source of Lead' },
  {
    accessorKey: 'lastActivityTime',
    header: 'Last activity time',
    cell: ({ row }) => (
      <DateFormatter dateTime={row?.original?.lastActivityTime} />
    ),
  },
  {
    accessorKey: 'modifiedTime',
    header: 'Modified time',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.modifiedTime} />,
  },
  { accessorKey: 'salesLeadStatus', header: 'Sales lead status' },
  { accessorKey: 'modifiedBy', header: 'Modified by' },
  { accessorKey: 'otherReason', header: 'Other reason' },
  { accessorKey: 'gstin', header: 'GSTIN' },
  { accessorKey: 'reasonOfLostLead', header: 'Reason of lost lead' },
];


const CRM_DETAIL_TABS = ['Overview', 'Timeline'];
const CRM_TIMELINE_TABS = ['History', 'Interactions'];
const CRM_STAGE_SELECT_OPTIONS = [
  'New Lead',
  'RNR',
  'First Call Sales Pitch(FCSP)',
  'Seeded',
  'Follow Up',
  'Lead Lost',
];

const CRM_TIMELINE_ITEMS = [
  {
    time: '03:36 PM',
    title: 'RM assigned/updated',
    lines: ['Old: Admin test', 'New: Tester 123'],
    meta: 'by Pavan shinde Jun 22, 2026',
  },
  {
    time: '03:36 PM',
    title: 'RM assigned/updated',
    lines: ['Old: Tester 123', 'New: Admin test'],
    meta: 'by Pavan shinde Jun 22, 2026',
  },
  {
    time: '03:36 PM',
    title: 'RM assigned/updated',
    lines: ['Old: Sameer Sheikh', 'New: Tester 123'],
    meta: 'by Pavan shinde Jun 22, 2026',
  },
  {
    time: '02:09 PM',
    title: 'RM assigned/updated',
    lines: ['Old: Tester 123', 'New: Sameer Sheikh'],
    meta: 'by Pavan shinde Jun 22, 2026',
  },
  {
    time: '01:30 PM',
    title: 'RM assigned/updated',
    lines: ['Old: Not Available', 'New: Tester 123'],
    meta: 'by Pavan shinde Jun 22, 2026',
  },
];

const DETAIL_GROUPS = [
  {
    title: 'Company Address',
    columns: 2,
    sections: [
      [
        { label: 'Country', key: 'countryId' },
        { label: 'City', key: 'cityId' },
        { label: 'Street', key: 'street' },
      ],
      [
        { label: 'State', key: 'stateId' },
        { label: 'Zip Code', key: 'zipCode' },
      ],
    ],
  },
  {
    title: 'First Call Sales Pitch (FCSP)',
    columns: 2,
    sections: [
      [
        { label: 'Type of Polymer', key: 'typeOfPolymer' },
        {
          label: 'Average Consumption / Selling (Monthly) in Tons',
          key: 'averageConsumption',
        },
        { label: 'Upload Calling Audio', key: 'uploadCallingAudio' },
        { label: 'Other - Reason', key: 'otherReason' },
      ],
      [
        { label: 'Type of Client', key: 'typeOfClient' },
        { label: 'Upload Whatsapp Image', key: 'uploadWhatsappImage' },
        { label: 'Upload Visiting Card', key: 'uploadVisitingCard' },
        {
          label: 'Whatsapp Audio and Image Upload Status',
          key: 'whatsappUploadStatus',
        },
      ],
    ],
  },
  {
    title: 'Seeded',
    columns: 2,
    sections: [
      [
        { label: 'App Downloaded', key: 'appDownloaded' },
        { label: 'Customer ID', key: 'customerId' },
        {
          label: 'Registered Contact Person Name on App',
          key: 'registeredContactPersonNameOnApp',
        },
        { label: 'Email Address on App', key: 'emailAddressOnApp' },
        { label: 'Plan Expiry date', key: 'planExpiryDate' },
      ],
      [
        { label: 'KYC Completed', key: 'kycCompleted' },
        { label: 'Registered GSTIN', key: 'registeredGstin' },
        {
          label: 'Registered Mobile Number on App',
          key: 'registeredMobileNumberOnApp',
        },
        {
          label: 'Subscription Details - Plan Type',
          key: 'subscriptionPlanType',
        },
        { label: 'Seeded Time', key: 'seededTime' },
      ],
    ],
  },
  {
    title: 'Lead Lost',
    columns: 2,
    sections: [
      [{ label: 'Reason for Lost lead', key: 'reasonForLostLead' }],
      [{ label: 'API Data Lead', key: 'apiDataLead' }],
    ],
  },
];

const LEAD_INFORMATION_LEFT_FIELDS = [
  { label: 'Lead Owner', key: 'leadOwner' },
  { label: 'Company Name', key: 'companyName' },
  { label: 'Email', key: 'email' },
  { label: 'Website', key: 'website' },
  { label: 'Phone No. Count', key: 'phoneNoCount' },
  { label: 'Phone 1', key: 'phone1' },
  { label: 'Currency', key: 'currency' },
  { label: 'Exchange Rate', key: 'exchangeRate' },
  { label: 'Company Intro', key: 'companyIntro' },
  {
    label: 'Pitched For Ad Space',
    key: 'pitchedForAdSpace',
    type: 'select',
    options: ['Yes', 'No'],
  },
];

const LEAD_INFORMATION_RIGHT_FIELDS = [
  {
    label: 'Lead Stage',
    key: 'leadStage',
    type: 'select',
    options: CRM_STAGE_SELECT_OPTIONS,
  },
  { label: 'Lead Name', key: 'leadName' },
  { label: 'Lead Person Designation', key: 'leadPersonDesignation' },
  { label: 'Sales Lead Status', key: 'salesLeadStatus' },
  { label: 'Email 2', key: 'email2' },
  { label: 'GSTIN', key: 'gstin' },
  { label: 'RNR', key: 'rnr' },
  { label: 'Follow Up Count', key: 'followUpCount' },
  { label: 'Created By', key: 'createdBy' },
  { label: 'Modified By', key: 'modifiedBy' },
  { label: 'App ID', key: 'appId' },
  { label: 'Source of Lead', key: 'sourceOfLead' },
  { label: 'Landline no.', key: 'landlineNo' },
  { label: 'Business Description', key: 'businessDescription' },
];

const CREATE_LEAD_STAGE_OPTIONS = [
  'New Lead',
  'RNR',
  'First Call Sales Pitch(FCSP)',
  'Seeded',
  'Follow Up',
  'Lead Lost',
];
const CREATE_LEAD_PERSON_DESIGNATION_OPTIONS = [
  '-None-',
  'Owner',
  'Manager',
  'Sales Executive',
  'Director',
];
const CREATE_LEAD_PHONE_COUNT_OPTIONS = ['1', '2', '3', '4', '5'];
const CREATE_LEAD_RNR_OPTIONS = ['-None-', 'Yes', 'No'];
const CREATE_LEAD_FOLLOW_UP_OPTIONS = ['-None-', '1', '2', '3', '4', '5'];
const CREATE_LEAD_PITCHED_FOR_AD_SPACE_OPTIONS = ['-None-', 'Yes', 'No'];

const CREATE_LEAD_SECTIONS = [
  {
    title: 'Lead Information',
    leftFields: [
      { key: 'leadOwner', label: 'Lead Owner', type: 'select', options: [], required: false },
      { key: 'firstName', label: 'First Name', type: 'text', required: false },
      { key: 'companyName', label: 'Company Name', type: 'text', required: false },
      { key: 'email', label: 'Email', type: 'text', required: true },
      { key: 'website', label: 'Website', type: 'text', required: false },
      { key: 'phoneNoCount', label: 'Phone No. Count', type: 'select', options: CREATE_LEAD_PHONE_COUNT_OPTIONS, required: false },
      { key: 'phone1', label: 'Phone 1', type: 'text', required: true },
      { key: 'currency', label: 'Currency', type: 'select', options: [], required: false },
      { key: 'exchangeRate', label: 'Exchange Rate', type: 'text', required: false },
      { key: 'companyIntro', label: 'Company Intro', type: 'textarea', required: false },
    ],
    rightFields: [
      { key: 'leadStage', label: 'Lead Stage', type: 'select', options: CREATE_LEAD_STAGE_OPTIONS, required: false },
      { key: 'lastName', label: 'Last Name', type: 'text', required: false },
      { key: 'leadPersonDesignation', label: 'Lead Person Designation', type: 'select', options: CREATE_LEAD_PERSON_DESIGNATION_OPTIONS, required: false },
      { key: 'salesLeadStatus', label: 'Sales Lead Status', type: 'text', required: false },
      { key: 'email2', label: 'Email 2', type: 'text', required: false },
      { key: 'gstin', label: 'GSTIN', type: 'text', required: false },
      { key: 'rnr', label: 'RNR', type: 'select', options: CREATE_LEAD_RNR_OPTIONS, required: false },
      { key: 'followUpCount', label: 'Follow Up Count', type: 'select', options: CREATE_LEAD_FOLLOW_UP_OPTIONS, required: false },
      { key: 'appId', label: 'App ID', type: 'text', required: false },
      { key: 'sourceOfLead', label: 'Source of Lead', type: 'text', required: false },
      { key: 'landlineNo', label: 'Landline no.', type: 'text', required: false },
      { key: 'pitchedForAdSpace', label: 'Pitched For Ad. Space', type: 'select', options: CREATE_LEAD_PITCHED_FOR_AD_SPACE_OPTIONS, required: false },
      { key: 'businessDescription', label: 'Business Description', type: 'textarea', required: false },
    ],
  },
  {
    title: 'Company Address',
    leftFields: [
      { key: 'countryId', label: 'Country', type: 'select', options: [], required: false },
      { key: 'cityId', label: 'City', type: 'select', options: [], required: false },
      { key: 'street', label: 'Street', type: 'text', required: false },
    ],
    rightFields: [
      { key: 'stateId', label: 'State', type: 'select', options: [], required: false },
      { key: 'zipCode', label: 'Zip Code', type: 'text', required: false },
    ],
  },
  {
    title: 'First Call Sales Pitch (FCSP)',
    leftFields: [
      { key: 'typeOfPolymer', label: 'Type of Polymer', type: 'select', options: [], required: false },
      { key: 'averageConsumption', label: 'Average Consumption / Selling (Monthly) in Tons', type: 'text', required: false },
      { key: 'uploadCallingAudio', label: 'Upload Calling Audio', type: 'upload', required: false },
      { key: 'otherReason', label: 'Other - Reason', type: 'textarea', required: false },
    ],
    rightFields: [
      { key: 'typeOfClient', label: 'Type of Client', type: 'select', options: ['-None-', 'Trader', 'Manufacturer', 'Exporter', 'Other'], required: false },
      { key: 'uploadWhatsappImage', label: 'Upload Whatsapp Image', type: 'upload', required: false },
      { key: 'uploadVisitingCard', label: 'Upload Visiting Card', type: 'upload', required: false },
      { key: 'whatsappUploadStatus', label: 'Whatsapp Audio and Image Upload Status', type: 'select', options: ['-None-', 'Pending', 'Uploaded', 'Skipped'], required: false },
    ],
  },
  {
    title: 'Seeded',
    leftFields: [
      { key: 'appDownloaded', label: 'App Downloaded', type: 'select', options: ['-None-', 'Yes', 'No'], required: false },
      { key: 'customerId', label: 'Customer ID', type: 'text', required: false },
      { key: 'registeredContactPersonNameOnApp', label: 'Registered Contact Person Name on App', type: 'text', required: false },
      { key: 'emailAddressOnApp', label: 'Email Address on App', type: 'text', required: false },
      { key: 'planExpiryDate', label: 'Plan Expiry date', type: 'date', required: false },
    ],
    rightFields: [
      { key: 'kycCompleted', label: 'KYC Completed', type: 'select', options: ['-None-', 'Yes', 'No'], required: false },
      { key: 'registeredGstin', label: 'Registered GSTIN', type: 'text', required: false },
      { key: 'registeredMobileNumberOnApp', label: 'Registered Mobile Number on App', type: 'text', required: false },
      { key: 'subscriptionPlanType', label: 'Subscription Details - Plan Type', type: 'select', options: ['-None-', 'Free Trial 30D', 'Paid', 'Custom'], required: false },
      { key: 'seededTime', label: 'Seeded Time', type: 'datetime-local', required: false },
    ],
  },
  {
    title: 'Lead Lost',
    leftFields: [
      { key: 'reasonForLostLead', label: 'Reason for Lost lead', type: 'select', options: ['-None-', 'Delay in follow up', 'Budget issue', 'Competitor chosen', 'No requirement', 'Other'], required: false },
    ],
    rightFields: [
      { key: 'apiDataLead', label: 'API Data Lead', type: 'text', required: false },
    ],
  },
];

const CREATE_LEAD_FIELDS = CREATE_LEAD_SECTIONS.flatMap((section) => [
  ...(section.leftFields || []),
  ...(section.rightFields || []),
]);

const HEADER_MAP = {
  date: 'date',
  'lead name': 'leadName',
  leadname: 'leadName',
  'company name': 'companyName',
  companyname: 'companyName',
  'lead stage': 'leadStage',
  leadstage: 'leadStage',
  number: 'number',
  email: 'email',
  reason: 'reason',
  'created time': 'createdTime',
  createdtime: 'createdTime',
  'source of lead': 'sourceOfLead',
  sourceoflead: 'sourceOfLead',
  'last activity time': 'lastActivityTime',
  lastactivitytime: 'lastActivityTime',
  'modified time': 'modifiedTime',
  modifiedtime: 'modifiedTime',
  'sales lead status': 'salesLeadStatus',
  salesleadstatus: 'salesLeadStatus',
  'modified by': 'modifiedBy',
  modifiedby: 'modifiedBy',
  'other reason': 'otherReason',
  otherreason: 'otherReason',
  gstin: 'gstin',
  'reason of lost lead': 'reasonOfLostLead',
  reasonoflostlead: 'reasonOfLostLead',
};

const createBlankForm = () =>
  CREATE_LEAD_FIELDS.reduce((acc, field) => {
    acc[field.key] = '';
    return acc;
  }, {});

const formatDisplayDate = (value, format = 'D MMM, YYYY') => {
  if (!value) return 'N/A';
  const parsedValue = moment(value);
  if (!parsedValue.isValid()) return value;
  return parsedValue.format(format);
};

const formatDisplayDateTime = (value) => {
  if (!value) return 'N/A';
  const parsedValue = moment(value);
  if (!parsedValue.isValid()) return value;
  return parsedValue.format('D MMM, YYYY hh:mm A');
};

const formatDisplayTime = (value) => {
  if (!value) return '— ';
  const parsedValue = moment(value);
  if (!parsedValue.isValid()) return value;
  return parsedValue.format('hh:mm A');
};

const CSV_DATE_INPUT_FORMATS = [
  moment.ISO_8601,
  'DD/MM/YYYY',
  'D/M/YYYY',
  'YYYY-MM-DD',
  'MM/DD/YYYY',
];

const CSV_DATETIME_INPUT_FORMATS = [
  moment.ISO_8601,
  'DD/MM/YYYY HH:mm',
  'D/M/YYYY HH:mm',
  'DD/MM/YYYY h:mm A',
  'D/M/YYYY h:mm A',
  'YYYY-MM-DD HH:mm',
  'YYYY-MM-DD HH:mm:ss',
  'YYYY-MM-DDTHH:mm',
  'YYYY-MM-DDTHH:mm:ss',
  'MM/DD/YYYY HH:mm',
];

const cleanCsvText = (text) => `${text || ''}`.replace(/^\uFEFF/, '');

const detectCsvDelimiter = (line) => {
  const candidates = [',', ';', '\t', '|'];

  return candidates
    .map((delimiter) => ({
      delimiter,
      count: (line.match(new RegExp(`\\${delimiter}`, 'g')) || []).length,
    }))
    .sort((left, right) => right.count - left.count)[0]?.delimiter || ',';
};

const parseExcelDate = (value) => {
  if (!value) return '';

  const rawValue = `${value}`.trim();
  if (!rawValue) return '';

  const parsedValue = moment(rawValue, CSV_DATE_INPUT_FORMATS, true);
  if (parsedValue.isValid()) {
    return parsedValue.format('YYYY-MM-DD');
  }

  const fallbackValue = moment(rawValue);
  if (fallbackValue.isValid()) {
    return fallbackValue.format('YYYY-MM-DD');
  }

  return rawValue;
};

const parseExcelDateTime = (value) => {
  if (!value) return '';

  const rawValue = `${value}`.trim();
  if (!rawValue) return '';

  const parsedValue = moment(rawValue, CSV_DATETIME_INPUT_FORMATS, true);
  if (parsedValue.isValid()) {
    return parsedValue.format('YYYY-MM-DDTHH:mm:ss');
  }

  const fallbackValue = moment(rawValue);
  if (fallbackValue.isValid()) {
    return fallbackValue.format('YYYY-MM-DDTHH:mm:ss');
  }

  return rawValue;
};

const normalizeImportedLead = (lead) => ({
  ...lead,
  date: parseExcelDate(lead?.date),
  createdTime: parseExcelDateTime(lead?.createdTime),
  lastActivityTime: parseExcelDateTime(lead?.lastActivityTime),
  modifiedTime: parseExcelDateTime(lead?.modifiedTime),
});

const normalizeCsvKey = (header) =>
  `${header || ''}`.trim().toLowerCase().replace(/\s+/g, '');

const splitDelimitedLine = (line, delimiter) => {
  const values = [];
  let current = '';
  let insideQuotes = false;

  for (let index = 0; index < line.length; index += 1) {
    const char = line[index];
    const nextChar = line[index + 1];

    if (char === '"' && insideQuotes && nextChar === '"') {
      current += '"';
      index += 1;
    } else if (char === '"') {
      insideQuotes = !insideQuotes;
    } else if (char === delimiter && !insideQuotes) {
      values.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }

  values.push(current.trim());
  return values;
};

const parseCsvText = (text) => {
  const rows = [];
  const lines = cleanCsvText(text)
    .replace(/\r\n/g, '\n')
    .split('\n')
    .filter((line) => line.trim().length > 0);

  if (!lines.length) return rows;

  const delimiter = detectCsvDelimiter(lines[0]);
  const headers = splitDelimitedLine(lines[0], delimiter).map(
    (header) => HEADER_MAP[normalizeCsvKey(header)] || normalizeCsvKey(header),
  );

  lines.slice(1).forEach((line, lineIndex) => {
    const values = splitDelimitedLine(line, delimiter);
    const row = { id: `csv-${Date.now()}-${lineIndex + 1}` };

    headers.forEach((headerKey, index) => {
      if (!headerKey) return;
      row[headerKey] = values[index] || '';
    });

    if (row.leadName || row.companyName) {
      rows.push(normalizeImportedLead(row));
    }
  });

  return rows;
};

// eslint-disable-next-line no-unused-vars
const parseSpreadsheetRows = async (file) => {
  const fileName = `${file?.name || ''}`.toLowerCase();

  if (fileName.endsWith('.csv')) {
    const text = await file.text();
    return parseCsvText(text);
  }

  if (fileName.endsWith('.xlsx') || fileName.endsWith('.xls')) {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: 'array' });
    const firstSheetName = workbook?.SheetNames?.[0];
    if (!firstSheetName) return [];

    const sheet = workbook.Sheets[firstSheetName];
    const jsonRows = XLSX.utils.sheet_to_json(sheet, {
      defval: '',
      raw: false,
    });

    return jsonRows
      .map((row, index) => {
        const normalizedRow = {
          id: `sheet-${Date.now()}-${index + 1}`,
        };

        Object.entries(row).forEach(([key, value]) => {
          const normalizedKey =
            HEADER_MAP[normalizeCsvKey(key)] || normalizeCsvKey(key);
          normalizedRow[normalizedKey] = value;
        });

        return normalizeImportedLead(normalizedRow);
      })
      .filter((row) => row.leadName || row.companyName);
  }

  throw new Error('Unsupported file type. Please upload CSV or Excel file.');
};

const createLeadDetailSnapshot = (lead, currencyOptions = []) => ({
  leadOwner: lead?.leadOwnerId || lead?.leadOwner?.id || lead?.leadOwner || lead?.leadOwnerName || '—',
  leadStage: lead?.leadStage || '—',
  companyName: lead?.companyName || '—',
  leadName: getLeadDisplayName(lead) || '—',
  email: lead?.email || '—',
  leadPersonDesignation: lead?.leadPersonDesignation || '—',
  website: lead?.website || '—',
  salesLeadStatus: lead?.salesLeadStatus || '—',
  phoneNoCount: lead?.phoneNoCount || '—',
  email2: lead?.email2 || '—',
  phone1: lead?.phone1 || lead?.registeredMobileNumberOnApp || lead?.number || '—',
  gstin: lead?.gstin || lead?.registeredGSTIN || '—',
  currency: getLeadCurrencyDisplayValue(lead, currencyOptions),
  rnr: lead?.rnr ? 'Yes' : (lead?.rnr === false ? 'No' : '—'),
  exchangeRate: lead?.exchangeRate || '—',
  followUpCount: lead?.followUpCount || '—',
  companyIntro: lead?.companyIntro || '—',
  createdBy: {
    name: lead?.leadOwnerName || '—',
    time: formatDisplayDateTime(lead?.createdAt) || '—',
  },
  pitchedForAdSpace: lead?.pitchedForAdSpace ? 'Yes' : (lead?.pitchedForAdSpace === false ? 'No' : '—'),
  modifiedBy: {
    name: lead?.leadOwnerName || '—',
    time: formatDisplayDateTime(lead?.modifiedTime) || '—',
  },
  appId: lead?.appId || '—',
  sourceOfLead: lead?.sourceOfLead || '—',
  landlineNo: lead?.landlineNo || '—',
  businessDescription: lead?.businessDescription || '—',
  street: lead?.street || '—',
  city: lead?.cityId || lead?.city?.id || lead?.city || lead?.cityName || '—',
  country: lead?.countryId || lead?.country?.id || lead?.country || lead?.countryName || '—',
  countryId: lead?.countryId || '',
  stateId: lead?.stateId || '',
  cityId: lead?.cityId || '',
  zipCode: lead?.zipCode || '—',
  state: lead?.stateId || lead?.state?.id || lead?.state || lead?.stateName || '—',
  typeOfPolymer: lead?.polymerTypeId || lead?.polymerType?.id || lead?.polymerType || lead?.polymerTypeName || '—',
  averageConsumption: lead?.averageConsumptionMonthlyTons || '—',
  uploadCallingAudio: lead?.callingAudio || '—',
  otherReason: lead?.otherReason || '—',
  typeOfClient: lead?.clientType || '—',
  uploadWhatsappImage: lead?.whatsappImage || '—',
  uploadVisitingCard: lead?.visitingCard || '—',
  whatsappUploadStatus: lead?.whatsappAudioImageUploadStatus || '—',
  appDownloaded: lead?.appDownloaded ? 'Yes' : (lead?.appDownloaded === false ? 'No' : '—'),
  customerId: lead?.customerId || '—',
  registeredContactPersonNameOnApp: lead?.registeredContactPersonNameOnApp || '—',
  emailAddressOnApp: lead?.emailAddressOnApp || '—',
  planExpiryDate: lead?.planExpiryDate ? formatDisplayDate(lead?.planExpiryDate) : '—',
  kycCompleted: lead?.kycCompleted ? 'Yes' : (lead?.kycCompleted === false ? 'No' : '—'),
  registeredGstin: lead?.registeredGSTIN || lead?.gstin || '—',
  registeredMobileNumberOnApp: lead?.registeredMobileNumberOnApp || lead?.phone1 || '—',
  subscriptionPlanType: lead?.subscriptionPlan || '—',
  seededTime: lead?.seededTime ? formatDisplayDateTime(lead?.seededTime) : '—',
  reasonForLostLead: lead?.reasonForLostLead || '—',
  apiDataLead: lead?.apiDataLead || '—',
});

const DETAIL_CARD_TITLES = {
  notes: 'Notes',
  attachments: 'Attachments',
};

const CRM_LEAD_STAFF_FILTERS = {
  filter: [
    {
      key: 'userSearchFilter',
      value: '',
      type: 'STRING',
      op: 'LIKE',
    },
    {
      key: 'name',
      value: 'TRADER',
      setAttribute: 'roles',
      type: 'STRING',
      op: 'NOT_IN',
    },
    { ...defaultDeleteFilter },
    {
      key: 'userSearchFilter',
      value: '',
      type: 'STRING',
      op: 'LIKE',
    },
  ],
  pageNo: 1,
  pageSize: 10,
  sortCol: 'id',
  sortDirection: 'DESC',
  pagination: false,
};

const renderDetailValue = (value) => {
  if (value === null || value === undefined || value === '') return '— ';

  if (typeof value === 'object' && value?.name) {
    const hasRealName = value.name && value.name !== '—' && value.name !== '— ';

    return (
      <div className="crm-lead-page__field-value-group">
        {hasRealName ? (
          <span className="crm-lead-page__field-value">{value.name}</span>
        ) : null}
        {value.time ? (
          <span className="crm-lead-page__field-subvalue">{value.time}</span>
        ) : null}
      </div>
    );
  }

  return <span className="crm-lead-page__field-value">{`${value}`}</span>;
};

const DetailField = ({ label, value, fieldKey, isEditing, editValue, onEditStart, onEditChange, onEditSave, onEditCancel, isEditable, editType = 'text', editOptions = [], isLoading = false, selectError = null }) => {
  const isMissing = value === '— ' || value === '—' || !value;
  const uploadInputRef = useRef(null);

  const handleUploadFileChange = async (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('File size should not exceed 10 MB.');
      return;
    }

    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    const toastId = toast.loading(`Uploading file...`);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}common/upload-file`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const url = response?.data?.data;
      if (url) {
        onEditChange(url);
        toast.update(toastId, { render: 'File uploaded successfully', type: 'success', isLoading: false, autoClose: 2000 });
      } else {
        toast.update(toastId, { render: 'Failed to upload file', type: 'error', isLoading: false, autoClose: 3000 });
        onEditChange(file.name);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.update(toastId, { render: 'Error uploading file', type: 'error', isLoading: false, autoClose: 3000 });
      onEditChange(file.name);
    }
  };

  return (
    <div className="crm-lead-page__field">
      <span className="crm-lead-page__field-label">{label}</span>
      <div className="crm-lead-page__field-content">
        {isEditing ? (
          <div className="d-flex align-items-center gap-1 w-100">
            {editType === 'select' ? (
              <Select
                className="crm-lead-create__select flex-grow-1"
                classNamePrefix="crm-create-select"
                options={editOptions}
                value={
                  editOptions.find(o =>
                    String(o.value) === String(editValue) ||
                    String(o.label) === String(editValue),
                  ) || null
                }
                onChange={(option) => {
                  onEditChange(option ? option.value : '');
                }}
                isSearchable
                styles={{
                  control: (base) => ({ ...base, minHeight: '28px', height: '28px' }),
                  dropdownIndicator: (base) => ({ ...base, padding: '2px' }),
                  valueContainer: (base) => ({ ...base, padding: '0 8px' }),
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, marginTop: 4, minWidth: '100%', zIndex: 9999 }),
                  menuList: (base) => ({ ...base, padding: 0, maxHeight: 220 }),
                  option: (base, state) => ({
                    ...base,
                    fontSize: 13,
                    padding: '8px 14px',
                    backgroundColor: state.isSelected ? '#2f80ed' : state.isFocused ? '#edf4ff' : '#ffffff',
                    color: state.isSelected ? '#ffffff' : '#111827',
                  }),
                }}
                isLoading={isLoading}
                isDisabled={isLoading || Boolean(selectError)}
                noOptionsMessage={() => {
                  if (selectError) {
                    return 'Unable to load users';
                  }

                  return 'No users found';
                }}
                autoFocus
                menuPortalTarget={typeof document === 'undefined' ? null : document.body}
                menuPlacement="auto"
                menuPosition="fixed"
              />
            ) : editType === 'date' || editType === 'datetime-local' ? (
              <Input
                type={editType}
                bsSize="sm"
                value={editValue}
                onChange={(e) => onEditChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') onEditSave();
                  if (e.key === 'Escape') onEditCancel();
                }}
                autoFocus
                className="py-0 px-1 m-0 flex-grow-1"
                style={{ minHeight: '28px', fontSize: '13px' }}
              />
            ) : editType === 'upload' ? (
              <div className="d-flex align-items-center gap-2 flex-grow-1">
                <input
                  ref={uploadInputRef}
                  type="file"
                  className="d-none"
                  onChange={handleUploadFileChange}
                />
                <Button
                  type="button"
                  color="light"
                  className="border py-0 px-2"
                  style={{ fontSize: '12px', minHeight: '28px' }}
                  onClick={() => uploadInputRef.current?.click()}
                >
                  Choose File
                </Button>
                <span className="text-muted text-truncate" style={{ fontSize: '12px', maxWidth: '140px' }} title={editValue}>
                  {editValue && editValue.startsWith('http') ? (
                    <a href={editValue} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>
                      {editValue.substring(editValue.lastIndexOf('/') + 1)}
                    </a>
                  ) : (
                    editValue || 'No file chosen'
                  )}
                </span>
              </div>
            ) : (
              <Input
                type="text"
                bsSize="sm"
                value={editValue}
                onChange={(e) => onEditChange(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') onEditSave();
                  if (e.key === 'Escape') onEditCancel();
                }}
                autoFocus
                className="py-0 px-1 m-0 flex-grow-1"
                style={{ minHeight: '28px', fontSize: '13px' }}
              />
            )}
            <Button color="link" className="p-0 text-success ms-1 flex-shrink-0" onClick={onEditSave}><FiCheck size={16} /></Button>
            <Button color="link" className="p-0 text-danger ms-1 flex-shrink-0" onClick={onEditCancel}><FiX size={16} /></Button>
          </div>
        ) : (
          <div
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                if (isEditable) onEditStart(fieldKey);
              }
            }}
            onClick={() => { if (isEditable) onEditStart(fieldKey); }}
            className={isEditable ? "cursor-pointer crm-lead-page__editable-field" : ""}
            title={isEditable ? "Click to edit" : ""}
            style={isEditable ? { cursor: 'pointer', display: 'inline-block', minWidth: '30px', borderBottom: '1px dashed #ccc' } : {}}
          >
            {(() => {
              if (editType === 'select' && Array.isArray(editOptions) && editOptions.length > 0) {
                const foundOpt = editOptions.find(o =>
                  String(o.value) === String(value) ||
                  String(o.label) === String(value),
                );
                if (foundOpt) return <span className="crm-lead-page__field-value">{foundOpt.label}</span>;
              }
              if (editType === 'upload' && value && value.startsWith('http')) {
                return (
                  <span className="crm-lead-page__field-value">
                    <a href={value} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} style={{ wordBreak: 'break-all' }}>
                      {value}
                    </a>
                  </span>
                );
              }
              return renderDetailValue(value);
            })()}
            {isEditable && !isMissing && <FiEdit2 size={12} className="ms-1 text-muted" />}
          </div>
        )}
        {(label === 'Phone 1' || label === 'Registered Mobile Number on App') && !isEditing ? (
          <span className="crm-lead-page__phone-chip" aria-hidden="true">
            <FiPhoneCall size={12} />
          </span>
        ) : null}
      </div>
    </div>
  );
};

const selectFieldStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 30,
    height: 30,
    width: '100%',
    borderColor: state.isFocused ? '#8ab4f8' : '#d9dde7',
    borderRadius: 6,
    boxShadow: state.isFocused ? '0 0 0 2px rgba(13, 110, 253, 0.12)' : 'none',
    backgroundColor: '#ffffff',
    '&:hover': {
      borderColor: state.isFocused ? '#8ab4f8' : '#cbd5e1',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: '0 16px',
    height: 30,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: 30,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 4,
    color: '#6b7280',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (base) => ({
    ...base,
    marginTop: 4,
    minWidth: '100%',
    zIndex: 20,
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
    maxHeight: 220,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, state) => ({
    ...base,
    fontSize: 13,
    padding: '8px 14px',
    backgroundColor: state.isSelected
      ? '#2f80ed'
      : state.isFocused
        ? '#edf4ff'
        : '#ffffff',
    color: state.isSelected ? '#ffffff' : '#111827',
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: 13,
    color: '#111827',
    fontWeight: 500,
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: 13,
    color: '#111827',
    fontWeight: 500,
  }),
};

const CRMLead = () => {
  const attachmentInputRef = useRef(null);
  const leadImageInputRef = useRef(null);
  const [leads, setLeads] = useState([]);
  const [isLeadsLoading, setIsLeadsLoading] = useState(false);
  const [deleteLeadId, setDeleteLeadId] = useState(null);
  const [submittingLead, setSubmittingLead] = useState(false);
  const [showCreateLeadPage, setShowCreateLeadPage] = useState(false);
  const [formValues, setFormValues] = useState(createBlankForm());
  const [formErrors, setFormErrors] = useState({});
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [fetchedLeadDetail, setFetchedLeadDetail] = useState(null);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);
  const [activeDetailTab, setActiveDetailTab] = useState('Overview');
  const [activeTimelineTab, setActiveTimelineTab] = useState('History');
  const [attachmentName, setAttachmentName] = useState('');
  const [leadImageName, setLeadImageName] = useState('');
  const [leadImagePreviewUrl, setLeadImagePreviewUrl] = useState('');
  const [isUploadCsvModalOpen, setIsUploadCsvModalOpen] = useState(false);

  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);

  const productSelectFilter = useMemo(
    () => [{ ...defaultDeleteFilter }],
    [],
  );

  const {
    data: staffListData,
    loading: staffListLoading,
    error: staffListError,
  } = useQuery(STAFF_LIST_QUERY, {
    variables: CRM_LEAD_STAFF_FILTERS,
    fetchPolicy: 'network-only',
  });

  const { data: productListData, loading: productListLoading } = useQuery(PRODUCT_LIST, {
    variables: {
      filter: productSelectFilter,
      pageNo: 1,
      pageSize: 1000,
      sortCol: 'name',
      sortDirection: 'ASC',
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  const getStaffDisplayName = useCallback((user) => {
    const nameParts = [user?.firstName, user?.middleName, user?.lastName]
      .map((part) => (part || '').trim())
      .filter(Boolean);
    if (nameParts.length) return nameParts.join(' ');
    return user?.email || user?.phone || 'User';
  }, []);

  const getStaffRoleLabel = useCallback((user) => {
    const normalizeRole = (roleName = '') => roleName.replace(/_/g, ' ');
    const roleNames = (user?.roles || [])
      .map((role) => role?.name)
      .filter(Boolean)
      .map((role) => normalizeRole(role));
    const filteredRoles = roleNames.filter((role) => role !== 'TRADER');
    const rolesToShow = filteredRoles.length ? filteredRoles : roleNames;
    if (!rolesToShow.length) return 'ROLE';
    return rolesToShow.join(', ');
  }, []);

  const getStaffPhoneLabel = useCallback((user) => {
    const code = user?.callingCode?.callingCode || '';
    const phone = user?.phone || '';
    const number = `${code} ${phone}`.trim();
    return number || 'Phone N/A';
  }, []);

  const formatStaffOptionLabel = useCallback(
    (user) => getStaffDisplayName(user),
    [getStaffDisplayName],
  );

  const leadOwnerOptions = useMemo(
    () =>
      (staffListData?.usersFilter?.users || []).map((staff) => ({
        label: formatStaffOptionLabel(staff),
        value: `${staff?.id}`,
        user: staff,
      })),
    [formatStaffOptionLabel, staffListData?.usersFilter?.users],
  );

  const polymerTypeOptions = useMemo(
    () =>
      (productListData?.productList?.productList || []).map((product) => ({
        label: product?.name || `Product #${product?.id || ''}`,
        value: product?.id,
      })),
    [productListData?.productList?.productList],
  );

  const [fetchStatesByCountry, { data: statesData }] = useLazyQuery(STATES_BY_COUNTRY, { fetchPolicy: 'network-only' });
  const [fetchCitiesByState, { data: citiesData }] = useLazyQuery(CITY_BY_STATE, { fetchPolicy: 'network-only' });

  useEffect(() => {
    const token = getStoredToken();
    if (token) {
      axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/country-currency`, {
        headers: { Authorization: `Bearer ${token}` }
      }).then(res => {
        const countryData = res.data?.data || [];
        const countryOptions = countryData.map(c => ({ label: c.name, value: c.id }));
        setCountries(countryOptions);

        setCurrencies(buildCurrencyOptions(countryData));
      }).catch(console.error);
    }
  }, []);

  const [stagedEdits, setStagedEdits] = useState({});
  const [inlineEditKey, setInlineEditKey] = useState(null);
  const [inlineEditValue, setInlineEditValue] = useState('');
  const [isUpdatingLead, setIsUpdatingLead] = useState(false);



  const fetchLeadDetail = useCallback(async (id) => {
    try {
      const token = getStoredToken();
      if (!token) return;
      const response = await axios.get(`${CRM_API_ROOT}/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const leadData = normalizeLeadRecord(response.data);
      setFetchedLeadDetail(leadData);

      if (leadData.countryId) {
        fetchStatesByCountry({ variables: { country: Number(leadData.countryId) } });
      }
      if (leadData.stateId) {
        fetchCitiesByState({ variables: { state: Number(leadData.stateId) } });
      }
    } catch (error) {
      toast.error('Unable to fetch lead details.');
    }
  }, [fetchStatesByCountry, fetchCitiesByState]);

  const fetchLeads = useCallback(async (page = 0, limit = 10) => {
    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    setIsLeadsLoading(true);
    try {
      const response = await axios.get(CRM_API_ROOT, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          pageNo: page,
          pageSize: limit,
        },
      });

      const nextLeads = normalizeLeadListResponse(response?.data);
      setLeads(nextLeads);

      const totalItems = response?.data?.paging?.totalItems;
      if (totalItems === undefined) {
        setTotalCount(nextLeads.length);
      } else {
        setTotalCount(totalItems);
      }
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.warning;
      toast.error(apiMessage || error?.message || 'Unable to fetch leads.');
    } finally {
      setIsLeadsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLeads(currentPageNo - 1, pageSize);
  }, [fetchLeads, currentPageNo, pageSize]);

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const paginatedLeads = leads;
  const selectedLead = useMemo(
    () => {
      if (fetchedLeadDetail && `${fetchedLeadDetail.id}` === `${selectedLeadId}`) {
        return fetchedLeadDetail;
      }
      return leads.find((lead) => `${lead.id}` === `${selectedLeadId}`) || leads[0] || null;
    },
    [leads, selectedLeadId, fetchedLeadDetail],
  );
  const leadDetail = useMemo(
    () => createLeadDetailSnapshot(selectedLead, currencies),
    [selectedLead, currencies],
  );

  const getInlineEditInitialValue = (key, initialValue) => {
    if (key === 'currency') {
      const rawCurrencyValue = getLeadCurrencyValue(selectedLead);
      return findOptionByValueOrLabel(currencies, rawCurrencyValue)?.value || rawCurrencyValue || '';
    }

    // ---- NAYE 2 CASES ----
    if (key === 'planExpiryDate') {
      return selectedLead?.planExpiryDate || '';   // already 'YYYY-MM-DD' format me normalize hoti hai
    }

    if (key === 'seededTime') {
      const rawSeededTime = selectedLead?.seededTime || '';
      return rawSeededTime ? rawSeededTime.slice(0, 16) : '';  // 'YYYY-MM-DDTHH:mm' tak trim
    }
    // ---- KHATAM ----

    return initialValue;
  };

  const handleInlineEditStart = (key, initialValue) => {
    setInlineEditKey(key);
    const nextValue = getInlineEditInitialValue(key, initialValue);
    setInlineEditValue(nextValue === '— ' || nextValue === '—' ? '' : (nextValue || ''));
  };

  const handleUpdateStagedEdits = async (singleUpdateKey = null, singleUpdateValue = null) => {
    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    const updates = singleUpdateKey ? { [singleUpdateKey]: singleUpdateValue } : { ...stagedEdits };
    if (Object.keys(updates).length === 0) return;

    setIsUpdatingLead(true);

    // ---- Effective country/state/city nikalo (already saved + abhi ki update) ----
    let effectiveCountryId = stagedEdits.countryId !== undefined ? stagedEdits.countryId : selectedLead?.countryId;
    let effectiveStateId = stagedEdits.stateId !== undefined ? stagedEdits.stateId : selectedLead?.stateId;
    let effectiveCityId = stagedEdits.cityId !== undefined ? stagedEdits.cityId : selectedLead?.cityId;

    if (updates.countryId !== undefined) {
      effectiveCountryId = updates.countryId;
      effectiveStateId = null; // naya country -> purana state invalid ho jata hai
      effectiveCityId = null;
    }
    if (updates.stateId !== undefined) {
      effectiveStateId = updates.stateId;
      effectiveCityId = null; // naya state -> purani city invalid ho jati hai
    }
    if (updates.cityId !== undefined) {
      effectiveCityId = updates.cityId;
    }
    // ---- Block khatam ----

    const payload = {
      leadImage: null,
      leadOwnerId: null,
      leadStage: null,
      firstName: selectedLead.firstName || null,
      lastName: selectedLead.lastName || null,
      companyName: null,
      email: null,
      salesLeadStatus: null,
      website: null,
      email2: null,
      phoneNoCount: null,
      gstin: null,
      phone1: null,
      rnr: null,
      currencyId: null,
      exchangeRate: null,
      followUpCount: null,
      appId: null,
      companyIntro: null,
      sourceOfLead: null,
      landlineNo: null,
      pitchedForAdSpace: null,
      businessDescription: null,
      notes: selectedLead.notes || null,
      attachment: selectedLead.attachment || null,
      street: null,
      cityId: effectiveCityId ? Number(effectiveCityId) : null,
      stateId: effectiveStateId ? Number(effectiveStateId) : null,
      countryId: effectiveCountryId ? Number(effectiveCountryId) : null,
      zipCode: null,
      polymerTypeId: null,
      clientType: null,
      averageConsumptionMonthlyTons: null,
      whatsappImage: null,
      callingAudio: null,
      visitingCard: null,
      otherReason: null,
      whatsappAudioImageUploadStatus: null,
      appDownloaded: null,
      kycCompleted: null,
      customerId: null,
      registeredGSTIN: null,
      registeredContactPersonNameOnApp: null,
      registeredMobileNumberOnApp: null,
      emailAddressOnApp: null,
      subscriptionPlan: null,
      planExpiryDate: null,
      seededTime: null,
      reasonForLostLead: null,
      apiDataLead: null,
    };

    Object.entries(updates).forEach(([key, value]) => {
      if (key === 'leadName') {
        const parts = value.trim().split(' ');
        payload.firstName = parts[0] || null;
        payload.lastName = parts.slice(1).join(' ') || null;
      } else if (key === 'companyName') payload.companyName = value || null;
      else if (key === 'email') payload.email = value || null;
      else if (key === 'website') payload.website = value || null;
      else if (key === 'phoneNoCount') payload.phoneNoCount = value ? Number(value) : null;
      else if (key === 'phone1') payload.phone1 = value || null;
      else if (key === 'leadOwner') payload.leadOwnerId = value ? Number(value) : null;
      else if (key === 'leadStage') payload.leadStage = CREATE_LEAD_STAGE_MAP[value] || value || null;
      else if (key === 'currency') payload.currencyId = value ? Number(value) : null;
      else if (key === 'email2') payload.email2 = value || null;
      else if (key === 'gstin') payload.gstin = value || null;
      else if (key === 'followUpCount') payload.followUpCount = value ? Number(value) : null;
      else if (key === 'appId') payload.appId = value || null;
      else if (key === 'sourceOfLead') payload.sourceOfLead = value || null;
      else if (key === 'landlineNo') payload.landlineNo = value || null;
      else if (key === 'salesLeadStatus') payload.salesLeadStatus = value || null;
      else if (key === 'businessDescription') payload.businessDescription = value || null;
      else if (key === 'pitchedForAdSpace') {
        payload.pitchedForAdSpace = value === 'Yes' ? true : (value === 'No' ? false : null);
      }
      else if (key === 'typeOfClient') {
        payload.clientType = CREATE_LEAD_CLIENT_TYPE_MAP[value] || value || null;
      }
      else if (key === 'rnr') {
        payload.rnr = value === 'Yes' ? true : (value === 'No' ? false : null);
      }
      else if (key === 'exchangeRate') {
        payload.exchangeRate = value ? Number(value) : null;
      }
      else if (key === 'reasonForLostLead') {
        payload.reasonForLostLead = CREATE_LEAD_LOST_REASON_MAP[value] || value || null;
      }
      else if (key === 'uploadWhatsappImage') payload.whatsappImage = value || null;
      else if (key === 'uploadCallingAudio') payload.callingAudio = value || null;
      else if (key === 'uploadVisitingCard') payload.visitingCard = value || null;
      else if (key === 'whatsappUploadStatus') {
        payload.whatsappAudioImageUploadStatus =
          CREATE_LEAD_UPLOAD_STATUS_MAP[value] || value || null;
      }
      else if (key === 'appDownloaded') {
        payload.appDownloaded = value === 'Yes' ? true : (value === 'No' ? false : null);
      }
      else if (key === 'kycCompleted') {
        payload.kycCompleted = value === 'Yes' ? true : (value === 'No' ? false : null);
      }
      else if (key === 'subscriptionPlanType') {
        payload.subscriptionPlan = CREATE_LEAD_SUBSCRIPTION_PLAN_MAP[value] || value || null;
      }
      else if (key === 'planExpiryDate') payload.planExpiryDate = value || null;
      else if (key === 'seededTime') {
        payload.seededTime = value ? (value.length === 16 ? `${value}:00` : value) : null;
      }
      else if (key === 'street') payload.street = value || null;
      else if (key === 'cityId') payload.cityId = value ? Number(value) : null;
      else if (key === 'stateId') payload.stateId = value ? Number(value) : null;
      else if (key === 'countryId') payload.countryId = value ? Number(value) : null;
      else if (key === 'zipCode') payload.zipCode = value || null;
      else if (key === 'averageConsumption') payload.averageConsumptionMonthlyTons = value ? Number(value) : null;
      else if (key === 'typeOfPolymer') payload.polymerTypeId = value ? Number(value) : null;
      else if (key === 'otherReason') payload.otherReason = value || null;
      else if (key === 'customerId') payload.customerId = value || null;
      else if (key === 'registeredContactPersonNameOnApp') payload.registeredContactPersonNameOnApp = value || null;
      else if (key === 'emailAddressOnApp') payload.emailAddressOnApp = value || null;
      else if (key === 'registeredGstin') payload.registeredGSTIN = value || null;
      else if (key === 'registeredMobileNumberOnApp') payload.registeredMobileNumberOnApp = value || null;
      else if (key === 'apiDataLead') payload.apiDataLead = value || null;
      else if (key === 'companyIntro') payload.companyIntro = value || null;
      else if (key === 'notes') payload.notes = value || null;
      else if (key === 'attachment') payload.attachment = value || null;
      else if (key === 'leadPersonDesignation') {
        payload.leadPersonDesignation = CREATE_LEAD_PERSON_DESIGNATION_MAP[value] || value || null;
      }
    });

    try {
      const response = await axios.put(`${CRM_API_ROOT}/${selectedLeadId}`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success(response?.data?.message || 'Lead updated successfully.');
      if (singleUpdateKey === null) {
        setStagedEdits({});
      } else {
        setStagedEdits(prev => {
          const next = { ...prev };
          delete next[singleUpdateKey];
          return next;
        });
      }
      setInlineEditKey(null);
      await fetchLeadDetail(selectedLeadId);
      await fetchLeads(currentPageNo - 1, pageSize);
    } catch (error) {
      const apiMessage = error?.response?.data?.message || error?.response?.data?.error || error?.response?.data?.warning;
      toast.error(apiMessage || error?.message || 'Unable to update lead.');
    } finally {
      setIsUpdatingLead(false);
    }
  };

  const handleInlineEditSave = (key) => {
    // Cascade: when country changes, refetch states and clear state/city
    if (key === 'countryId') {
      if (inlineEditValue) {
        fetchStatesByCountry({ variables: { country: Number(inlineEditValue) } });
      }
      setStagedEdits(prev => ({ ...prev, stateId: '', cityId: '' }));
    }
    // Cascade: when state changes, refetch cities and clear city
    if (key === 'stateId') {
      if (inlineEditValue) {
        fetchCitiesByState({ variables: { state: Number(inlineEditValue) } });
      }
      setStagedEdits(prev => ({ ...prev, cityId: '' }));
    }
    handleUpdateStagedEdits(key, inlineEditValue);
  };

  const handleInlineEditCancel = () => {
    setInlineEditKey(null);
  };

  const renderDetailFieldBound = (fieldLabel, fieldKey, rawValue, customEditType, customEditOptions) => {
    const isEditable = Object.prototype.hasOwnProperty.call(INLINE_EDITABLE_FIELDS, fieldKey);
    const displayValue = stagedEdits[fieldKey] === undefined ? rawValue : stagedEdits[fieldKey];

    let derivedEditType = customEditType || 'text';
    let derivedEditOptions = customEditOptions || [];

    if (!customEditType) {
      const createLeadField = CREATE_LEAD_FIELDS.find(f => f.key === fieldKey);
      if (createLeadField && createLeadField.type === 'select') {
        derivedEditType = 'select';
        if (fieldKey === 'countryId') {
          derivedEditOptions = countries;
        } else if (fieldKey === 'stateId') {
          derivedEditOptions = (statesData?.statesByCountry || []).map(s => ({ label: s.stateName, value: s.id }));
        } else if (fieldKey === 'cityId') {
          derivedEditOptions = (citiesData?.citiesByState || []).map(c => ({ label: c.cityName, value: c.id }));
        } else if (fieldKey === 'leadOwner') {
          derivedEditOptions = leadOwnerOptions;
        } else if (fieldKey === 'leadStage') {
          derivedEditOptions = CRM_STAGE_SELECT_OPTIONS.map((option) => ({
            label: option,
            value: option,
          }));
        } else if (fieldKey === 'currency') {
          derivedEditOptions = currencies;
        } else if (fieldKey === 'typeOfPolymer') {
          derivedEditOptions = polymerTypeOptions;
        } else {
          derivedEditOptions = (createLeadField.options || [])
            .filter((option) => option !== '-None-')
            .map((option) => {
              if (typeof option === 'object' && option !== null) {
                return { label: option.label, value: option.value };
              }

              return { label: option, value: option };
            });
        }
      } else if (createLeadField && (createLeadField.type === 'date' || createLeadField.type === 'datetime-local')) {
        derivedEditType = createLeadField.type;   // 'date' ya 'datetime-local'
      } else if (createLeadField && createLeadField.type === 'upload') {
        derivedEditType = 'upload';
      }
    }

    return (
      <DetailField
        key={fieldKey}
        label={fieldLabel}
        value={displayValue}
        fieldKey={fieldKey}
        isEditable={isEditable}
        isEditing={inlineEditKey === fieldKey}
        editValue={inlineEditValue}
        onEditStart={() => handleInlineEditStart(fieldKey, rawValue)}
        onEditChange={setInlineEditValue}
        onEditSave={() => handleInlineEditSave(fieldKey)}
        onEditCancel={handleInlineEditCancel}
        editType={derivedEditType}
        editOptions={derivedEditOptions}
        isLoading={fieldKey === 'leadOwner' && staffListLoading}
        selectError={fieldKey === 'leadOwner' ? staffListError : null}
      />
    );
  };

  const openCreateLeadPage = () => {
    setShowCreateLeadPage(true);
    setFormErrors({});
    setFormValues(createBlankForm());
    setLeadImageName('');
    setLeadImagePreviewUrl('');
  };

  const closeCreateLeadPage = () => {
    setShowCreateLeadPage(false);
    setFormErrors({});
    setFormValues(createBlankForm());
    setLeadImageName('');
    setLeadImagePreviewUrl('');
  };

  const validateForm = (values) => {
    const nextErrors = {};

    CREATE_LEAD_FIELDS.filter((field) => field.required).forEach((field) => {
      if (!values[field.key]?.trim?.()) {
        nextErrors[field.key] = `${field.label} is required`;
      }
    });

    return nextErrors;
  };

  const handleInputChange = (fieldKey, value) => {
    setFormValues((prev) => ({
      ...prev,
      [fieldKey]: value,
    }));
  };

  const handleManualSubmit = (event) => {
    event.preventDefault();
    const nextErrors = validateForm(formValues);

    if (Object.keys(nextErrors).length > 0) {
      setFormErrors(nextErrors);
      toast.error('Please fill all mandatory fields.');
      return;
    }

    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    setSubmittingLead(true);
    const payload = buildCreateLeadPayload(formValues, leadImageName);

    axios
      .post(`${CRM_API_ROOT}/create`, payload, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (response) => {
        toast.success(response?.data?.message || 'Lead created successfully.');
        closeCreateLeadPage();
        await fetchLeads(currentPageNo - 1, pageSize);
      })
      .catch((error) => {
        const apiMessage =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.response?.data?.warning;
        toast.error(apiMessage || error?.message || 'Unable to create lead.');
      })
      .finally(() => {
        setSubmittingLead(false);
      });
  };

  const handleUploadComplete = async () => {
    await fetchLeads(currentPageNo - 1, pageSize);
  };

  const handlePageChange = ({ pageNo, pageSize: nextPageSize }) => {
    const computedTotalPages = Math.max(
      1,
      Math.ceil(totalCount / nextPageSize),
    );
    setPageSize(nextPageSize);
    setCurrentPageNo(Math.min(pageNo, computedTotalPages));
  };

  const handleLeadRowClick = (row) => {
    const id = row?.original?.id ?? null;
    setSelectedLeadId(id);
    setActiveDetailTab('Overview');
    setActiveTimelineTab('History');
    setAttachmentName('');

    if (id) {
      fetchLeadDetail(id);
    }

    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBackToList = () => {
    setSelectedLeadId(null);
    setFetchedLeadDetail(null);
    setActiveDetailTab('Overview');
    setActiveTimelineTab('History');
    setAttachmentName('');

    if (typeof window !== 'undefined') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleAttachmentChooseFile = () => {
    attachmentInputRef.current?.click();
  };

  const handleNoteChange = (e) => {
    setStagedEdits(prev => ({ ...prev, notes: e.target.value }));
  };

  const handleNoteSave = () => {
    const value = stagedEdits.notes !== undefined ? stagedEdits.notes : (selectedLead?.notes || '');
    handleUpdateStagedEdits('notes', value);
  };

  const handleNoteCancel = () => {
    setStagedEdits(prev => {
      const next = { ...prev };
      delete next.notes;
      return next;
    });
  };

  const handleAttachmentFileChange = async (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('File size should not exceed 10 MB.');
      return;
    }

    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    const toastId = toast.loading(`Uploading attachment...`);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}common/upload-file`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const url = response?.data?.data;
      if (url) {
        setAttachmentName(url);
        setStagedEdits(prev => ({ ...prev, attachment: url }));
        await handleUpdateStagedEdits('attachment', url);   // <-- YE NAYI LINE
        toast.update(toastId, { render: 'Attachment uploaded successfully', type: 'success', isLoading: false, autoClose: 2000 });
      } else {
        toast.update(toastId, { render: 'Failed to upload attachment', type: 'error', isLoading: false, autoClose: 3000 });
        setAttachmentName(file.name);
      }
    } catch (error) {
      console.error('Error uploading attachment:', error);
      toast.update(toastId, { render: 'Error uploading attachment', type: 'error', isLoading: false, autoClose: 3000 });
      setAttachmentName(file.name);
    }
  };

  const handleLeadImageChooseFile = () => {
    leadImageInputRef.current?.click();
  };

  const handleLeadImageFileChange = async (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('File size should not exceed 10 MB.');
      return;
    }

    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    setLeadImagePreviewUrl(URL.createObjectURL(file));

    const toastId = toast.loading(`Uploading image...`);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}common/upload-file`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const url = response?.data?.data;
      if (url) {
        setLeadImageName(url);
        toast.update(toastId, { render: 'Image uploaded successfully', type: 'success', isLoading: false, autoClose: 2000 });
      } else {
        toast.update(toastId, { render: 'Failed to upload image', type: 'error', isLoading: false, autoClose: 3000 });
        setLeadImageName(file.name);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      toast.update(toastId, { render: 'Error uploading image', type: 'error', isLoading: false, autoClose: 3000 });
      setLeadImageName(file.name);
    }
  };

  const handleDeleteLeadClick = useCallback((leadId) => {
    setDeleteConfirmId(leadId);
  }, []);

  const handleDeleteCancel = useCallback(() => {
    setDeleteConfirmId(null);
  }, []);

  const handleDeleteConfirm = useCallback(async () => {
    if (!deleteConfirmId) return;

    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    setDeleteLeadId(deleteConfirmId);
    try {
      const response = await axios.delete(`${CRM_API_ROOT}/${deleteConfirmId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      toast.success(response?.data?.message || 'Lead deleted successfully.');
      if (`${selectedLeadId}` === `${deleteConfirmId}`) {
        setSelectedLeadId(null);
        setFetchedLeadDetail(null);
      }
      await fetchLeads(currentPageNo - 1, pageSize);
    } catch (error) {
      const apiMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data?.warning;
      toast.error(apiMessage || error?.message || 'Unable to delete lead.');
    } finally {
      setDeleteLeadId(null);
      setDeleteConfirmId(null);
    }
  }, [deleteConfirmId, fetchLeads, selectedLeadId, currentPageNo, pageSize]);

  const handleCreateLeadUploadChange = async (fieldKey, event) => {
    const file = event.target?.files?.[0];
    if (!file) return;

    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      toast.error('File size should not exceed 10 MB.');
      return;
    }

    const token = getStoredToken();
    if (!token) {
      toast.error('Authentication token not found.');
      return;
    }

    const toastId = toast.loading(`Uploading file...`);
    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await axios.post(
        `${process.env.REACT_APP_REST_API_ENDPOINT}common/upload-file`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      const url = response?.data?.data;
      if (url) {
        handleInputChange(fieldKey, url);
        toast.update(toastId, { render: 'File uploaded successfully', type: 'success', isLoading: false, autoClose: 2000 });
      } else {
        toast.update(toastId, { render: 'Failed to upload file', type: 'error', isLoading: false, autoClose: 3000 });
        handleInputChange(fieldKey, file.name);
      }
    } catch (error) {
      console.error('Error uploading file:', error);
      toast.update(toastId, { render: 'Error uploading file', type: 'error', isLoading: false, autoClose: 3000 });
      handleInputChange(fieldKey, file.name);
    }
  };

  const columns = useMemo(
    () =>
      CRM_COLUMNS.map((column) => {
        if (column.accessorKey === 'date') {
          return {
            ...column,
            cell: ({ row }) =>
              renderNoWrapValue(
                formatDisplayDate(row?.original?.date, 'DD MMM YYYY'),
              ),
          };
        }

        if (column.accessorKey === 'createdTime') {
          return {
            ...column,
            cell: ({ row }) => formatDisplayDateTime(row?.original?.createdTime),
          };
        }

        if (column.accessorKey === 'lastActivityTime') {
          return {
            ...column,
            cell: ({ row }) =>
              formatDisplayDateTime(row?.original?.lastActivityTime),
          };
        }

        if (column.accessorKey === 'modifiedTime') {
          return {
            ...column,
            cell: ({ row }) => formatDisplayDateTime(row?.original?.modifiedTime),
          };
        }

        return column;
      }).concat([
        {
          id: 'actions',
          header: '',
          size: 72,
          minSize: 72,
          maxSize: 72,
          enableSorting: false,
          cell: ({ row }) =>
            renderLeadDeleteCell({
              row,
              onDelete: handleDeleteLeadClick,
              deletingId: deleteLeadId,
            }),
        },
      ]),
    [deleteLeadId, handleDeleteLeadClick],
  );

  const renderCreateLeadPage = () => (
    <CreateLead
      createLeadSections={CREATE_LEAD_SECTIONS}
      selectFieldStyles={selectFieldStyles}
      leadImageInputRef={leadImageInputRef}
      leadImageName={leadImageName}
      leadImagePreviewUrl={leadImagePreviewUrl}
      formValues={formValues}
      formErrors={formErrors}
      submittingLead={submittingLead}
      leadOwnerOptions={leadOwnerOptions}
      polymerTypeOptions={polymerTypeOptions}
      countries={countries}
      currencies={currencies}
      statesData={statesData}
      citiesData={citiesData}
      staffListLoading={staffListLoading}
      staffListError={staffListError}
      productListLoading={productListLoading}
      fetchStatesByCountry={fetchStatesByCountry}
      fetchCitiesByState={fetchCitiesByState}
      onClose={closeCreateLeadPage}
      onSubmit={handleManualSubmit}
      onInputChange={handleInputChange}
      onCreateLeadUploadChange={handleCreateLeadUploadChange}
      onLeadImageChooseFile={handleLeadImageChooseFile}
      onLeadImageFileChange={handleLeadImageFileChange}
    />
  );

  const renderDetailPage = () => (
    <UpdateLead
      leadDetail={leadDetail}
      selectedLead={selectedLead}
      stagedEdits={stagedEdits}
      inlineEditKey={inlineEditKey}
      inlineEditValue={inlineEditValue}
      isUpdatingLead={isUpdatingLead}
      activeDetailTab={activeDetailTab}
      activeTimelineTab={activeTimelineTab}
      attachmentInputRef={attachmentInputRef}
      attachmentName={attachmentName}
      detailTabs={CRM_DETAIL_TABS}
      timelineTabs={CRM_TIMELINE_TABS}
      timelineItems={CRM_TIMELINE_ITEMS}
      detailGroups={DETAIL_GROUPS}
      leadInformationLeftFields={LEAD_INFORMATION_LEFT_FIELDS}
      leadInformationRightFields={LEAD_INFORMATION_RIGHT_FIELDS}
      detailCardTitles={DETAIL_CARD_TITLES}
      onBackToList={handleBackToList}
      onUpdateStagedEdits={handleUpdateStagedEdits}
      onDetailTabChange={setActiveDetailTab}
      onTimelineTabChange={setActiveTimelineTab}
      onAttachmentChooseFile={handleAttachmentChooseFile}
      onAttachmentFileChange={handleAttachmentFileChange}
      onNoteChange={handleNoteChange}
      onNoteSave={handleNoteSave}
      onNoteCancel={handleNoteCancel}
      renderDetailFieldBound={renderDetailFieldBound}
      formatDisplayTime={formatDisplayTime}
    />
  );
  return (
    <div className="staff-page vendor-page crm-lead-page">
      {showCreateLeadPage ? (
        renderCreateLeadPage()
      ) : selectedLeadId ? (
        renderDetailPage()
      ) : (
        <GetLead
          paginatedLeads={paginatedLeads}
          totalCount={totalCount}
          totalPages={totalPages}
          columns={columns}
          currentPageNo={currentPageNo}
          pageSize={pageSize}
          isLeadsLoading={isLeadsLoading}
          deleteConfirmId={deleteConfirmId}
          isUploadCsvModalOpen={isUploadCsvModalOpen}
          onOpenCreateLead={openCreateLeadPage}
          onOpenUploadCsv={() => setIsUploadCsvModalOpen(true)}
          onToggleUploadCsv={() => setIsUploadCsvModalOpen(!isUploadCsvModalOpen)}
          onUploadComplete={handleUploadComplete}
          onPageChange={handlePageChange}
          onLeadRowClick={handleLeadRowClick}
          onDeleteCancel={handleDeleteCancel}
          onDeleteConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
};

export default CRMLead;

